import React from 'react';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import BusinessUnitList from 'components/Agile/businessUnit/businessUnitList';
import AppModuleHeader from 'components/AppModuleHeader/index';
import BusinessUnitAdd from 'components/Agile/businessUnit/businessUnitAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';

const filterOptions = [
    {
        id: 1,
        name: 'All business units',
        icon: 'zmdi-menu'
    }, {

        id: 2,
        name: 'Starred business units',
        icon: 'zmdi-star'
    }
];

export class Component extends React.Component {

    businessUnitSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.businessUnits" /></span>
                </div>
            </div>


            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onAddBusinessUnit}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="businessUnit.addBusinessUnit" /></span>
                        </Button>
                    </div>
                    <div className="module-side-nav">
                        <ul className="module-nav">
                            {filterOptions.map(option => <li key={option.id} className="nav-item">
                                <a href="javascript:void(0)"
                                    className={option.id === this.props.selectedSectionId ? 'active' : ''} onClick={
                                        this.onFilterBusinessUnitOptionSelect.bind(this, option)
                                    }>
                                    <i className={`zmdi ${option.icon}`} />
                                    <span>{option.name}</span>
                                </a>
                            </li>
                            )}

                        </ul>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    addFavouriteBusinessUnit = (data) => {
        this.props.addFavouriteBusinessUnit(data);
    };
    onBusinessUnitSelect = (data) => {
        this.props.onBusinessUnitSelect(data);
    };
    onAddBusinessUnit = () => {
        this.props.onAddBusinessUnit();
    };
    onBusinessUnitClose = () => {
        this.props.onBusinessUnitClose();
    };
    onFilterBusinessUnitOptionSelect = (option) => {
        this.props.onFilterBusinessUnitOptionSelect(option);
    };
    onSaveBusinessUnit = (data) => {
        this.props.onSaveBusinessUnit(data);
    };
    onDeleteBusinessUnit = (data) => {
        this.props.onDeleteBusinessUnit(data);
    };
    onFilterSelectedBusinessUnit = () => {
        this.props.onFilterSelectedBusinessUnit();
    };
    filterBusinessUnit = (businessUnitName) => {
        if (businessUnitName === '') {
            this.onFilterBusinessUnitOptionSelect(this.props.filterOption);
        } else {
            this.props.filterBusinessUnit(businessUnitName);
        }
    };
    handleBusinessUnitRequestClose = () => {
        this.props.handleBusinessUnitRequestClose();
    };
    getAllBusinessUnit = () => {
        this.props.getAllBusinessUnit();
    };
    getUnselectedAllBusinessUnit = () => {
        this.props.getUnselectedAllBusinessUnit();
    };
    onAllBusinessUnitSelect = () => {
        const selectAll = this.props.selectedBusinessUnits < this.props.businessUnitList.length;
        if (selectAll) {
            this.props.getAllBusinessUnit();
        } else {
            this.props.getUnselectedAllBusinessUnit();
        }
    };
    onToggleBusinessUnitDrawer = () => {
        this.props.onToggleBusinessUnitDrawer();
    };
    showBusinessUnitLoader = () => {
        this.props.showBusinessUnitLoader();
    }

    constructor() {
        super();
    }
    componentDidMount() {
        this.props.showBusinessUnitLoader();
        this.props.fetchBusinessUnits();
    }
    updateSearchBusinessUnit(evt) {
        this.props.updateSearchBusinessUnit(evt.target.value);
        this.props.filterBusinessUnit(evt.target.value);
    }

    render() {
        const {
            width,
            businessUnit,
            businessUnitList,
            addBusinessUnitState,
            selectedBusinessUnits,
            alertMessage,
            showMessage,
            drawerState,
            noContentFoundMessage,
            loader
        } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">
                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleBusinessUnitDrawer.bind(this)}
                            sidebar={this.businessUnitSideBar(businessUnit)} />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">
                        {this.businessUnitSideBar(businessUnit)}
                    </div>
                    <div className="module-box">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={this.onToggleBusinessUnitDrawer.bind(this)}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                            <AppModuleHeader placeholder="Search business unit" notification={false} apps={false}
                                user={this.props.businessUnit}
                                onChange={this.updateSearchBusinessUnit.bind(this)}
                                value={this.props.searchBusinessUnit} />
                        </div>
                        <div className="module-box-content">
                            <div className="module-box-topbar">
                                <div className="form-control-checkbox d-flex">
                                    <div className="form-checkbox">
                                        <input type="checkbox"
                                            checked={selectedBusinessUnits > 0}
                                            onChange={this.onAllBusinessUnitSelect.bind(this)} />
                                        <span className="check">
                                            <i className="zmdi zmdi-check zmdi-hc-lg" />
                                        </span>
                                    </div>
                                </div>
                                <Button size="sm" className="jr-btn jr-flat-btn" color="default"
                                    onClick={this.onFilterSelectedBusinessUnit.bind(this)}>
                                    <i className="zmdi zmdi-filter-list zmdi-hc-fw" />
                                    <span><IntlMessages id="label.filter.selected" /></span>
                                </Button>
                            </div>
                            <CustomScrollbars className="module-list-scroll scrollbar"
                                style={{ height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    businessUnitList && businessUnitList.length > 0 ?
                                        <BusinessUnitList data={businessUnitList} width={width}
                                            addFavouriteBusinessUnit={this.addFavouriteBusinessUnit.bind(this)}
                                            onBusinessUnitSelect={this.onBusinessUnitSelect.bind(this)}
                                            onDeleteBusinessUnit={this.onDeleteBusinessUnit.bind(this)}
                                            onSaveBusinessUnit={this.onSaveBusinessUnit.bind(this)}
                                            showBusinessUnitLoader={this.showBusinessUnitLoader.bind(this)} />
                                        :
                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                            {noContentFoundMessage}
                                        </div>
                                }
                            </CustomScrollbars>

                        </div>
                    </div>
                </div>
                <BusinessUnitAdd
                    open={addBusinessUnitState}
                    businessUnit={{
                        'id': '',
                        'orgid': '',
                        'name': '',
                        'thumb': null,
                        'selected': false,
                        'starred': false,
                        'frequently': false,
                    }}
                    onSaveBusinessUnit={this.onSaveBusinessUnit}
                    onBusinessUnitClose={this.onBusinessUnitClose}
                    onDeleteBusinessUnit={this.onDeleteBusinessUnit}
                    showBusinessUnitLoader={this.showBusinessUnitLoader}
                />

                {showMessage && NotificationManager.success(alertMessage, this.handleBusinessUnitRequestClose())}
                <NotificationContainer />

            </div>
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/businessUnit/component.js